<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import type { TextAlignType, InputType } from '#imports';

interface IProps {
    label?: string;
    clearable?: boolean;
    description?: string;
    icon?: IconDefinition;
    placeholder?: string;
    min?: number;
    max?: number;
    minLength?: number;
    maxLength?: number;
    type?: InputType;
    dir?: 'rtl' | 'ltr';
    align?: TextAlignType;
}
const {
    dir = 'rtl',
    max = Infinity,
    maxLength = Infinity,
    minLength = 0,
    min = Infinity,
    clearable,
    icon,
    description,
    label,
    type = 'text',
    placeholder,
    align,
} = defineProps<IProps>();
const modelValue = defineModel<string | number | null>();
</script>
<template>
    <mr-input
        v-model="modelValue"
        required
        :label
        :clearable
        :description
        full-width
        :icon
        :placeholder
        :min
        :max
        :min-length
        :max-length
        :type
        :dir
        :align
    />
</template>
